import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import { AppContext } from "../../Context";
import Fetch, { Loader, Get, priceFormat } from "../inc/Fetch";
import { ImageUpload, Input, Select } from "../components/Form";
import ErrorPage from "./ErrorPage";

import { GoSquareFill } from "react-icons/go";
import { MdArrowForwardIos } from "react-icons/md";


import Header from "./Header";
import Footer from "./Footer";

// ads

import './css/cp.css'

export default function Home() {

    const { t } = useTranslation();
    let ref = useRef();
    const params = useParams();

	const {successData, user} = useContext(AppContext); 
	const [userinfo, setuserinfo] = user;
    const [success, setsuccess] = successData;

    const [loader, setloader] = useState(false);
    const [loading, setloading] = useState(true);
    const [values, setvalues] = useState(userinfo);

    async function submit(e) {
        e.preventDefault();

        setloader(true);
        let res = await Fetch("userUpdate", values);
        if (res?.error) {
            setsuccess({ short: t("error",  { returnObjects: true })[res?.error], error: true });
        } else {
            setsuccess({ short: t("success_text") });
        }

        setloader(false);
    }

    useEffect(() => {

        if (userinfo?._id) {

            setvalues(
                { 
                    name: userinfo?.name,
                    img: userinfo?.img,
                    email: userinfo?.email,
                    cell: userinfo?.phones?.cell,
                    phone: userinfo?.phones?.phone,
                    company: userinfo?.company?.name,
                    job: userinfo?.company?.job,
                    employees: userinfo?.company?.employees,
                    url: userinfo?.company?.url,
                    address: userinfo?.address,
                    
                }
            );
            setloading(false);
        }
        
    }, [userinfo?._id]);
    
    if (!userinfo?._id && !loading) {
        return <ErrorPage />
    }

    if (loading) {
        return <Loader />
    }

	return (
		<>
            {loader && <Loader />}
            {/* {isFetching && <Loader />} */}
            <Helmet>
                <title>{t("user_account_info")}</title>
                <meta property="og:title" content={t("user_account_info")} />
            </Helmet>

			<Header /> 

            <nav className='mainWidth pathNames'> 
                <Link to='/'>{t("home")}</Link>
                <MdArrowForwardIos />
                <Link >{t("user_account_info")}</Link>
                
            </nav>

        

            <div className='mainWidth cpBox'>

                <ImageUpload 
                    title="" 
                    onChange={(v) => setvalues(p => ({
                        ...p,
                        img:v,
                    }))}
                    value={values?.img}
                    imgStyle={{borderRadius:100,  margin:"auto"}}
                    style={{ margin:"auto", maxWidth:200, }}
                />

                <div className='sideBySideAccountBox' style={{margin:"auto", display:"table"}}>

                    

                    <div className='sideBySideAccount' style={{display:"flex", }}>

                        <Input 
                            title={t("customers_fullname")}
                            name="name"
                            validate={true}
                            onChange={(v) => setvalues(p => ({
                                ...p,
                                name:v,
                            }))}
                            value={values?.name}
                            style={{ width:300, maxWidth:"unset"}}
                        />

                        <Input 
                            title={t("customers_email")}
                            name="email"
                            validate={true}
                            onChange={(v) => setvalues(p => ({
                                ...p,
                                email:v,
                            }))}
                            value={values?.email}
                            style={{width:300, maxWidth:"unset"}}
                        />

                    </div>

                    <div className='sideBySideAccount' style={{display:"flex", }}>

                        <Input 
                            title={t("login_pass")}
                            type="password"
                            validate={true}
                            onChange={(v) => setvalues(p => ({
                                ...p,
                                pass:v,
                            }))}
                            style={{ width:300, maxWidth:"unset"}}
                        />

                        <Input 
                            title={t("reg_pass_conf")}
                            type="password"
                            validate={true}
                            onChange={(v) => setvalues(p => ({
                                ...p,
                                pass2:v,
                            }))}
                            style={{width:300, maxWidth:"unset"}}
                        />

                    </div>

                    <div className='sideBySideAccount' style={{display:"flex", }}>

                        <Input 
                            title={t("customers_cell")}
                            name="Cellphone"
                            validate={true}
                            onChange={(v) => setvalues(p => ({
                                ...p,
                                cell:v,
                            }))}
                            value={values?.cell}
                            style={{width:300, maxWidth:"unset"}}
                        />

                        <Input 
                            title={t("customers_phone")}
                            name="Phone"
                            onChange={(v) => setvalues(p => ({
                                ...p,
                                phone:v,
                            }))}
                            value={values?.phone}
                            style={{width:300, maxWidth:"unset"}}
                        />
                    </div>

                    <div className='sideBySideAccount' style={{display:"flex", }}>

                        <Input 
                            title={t("customers_comp_name")}
                            name="Company"
                            onChange={(v) => setvalues(p => ({
                                ...p,
                                company:v,
                            }))}
                            value={values?.company}
                            style={{width:300, maxWidth:"unset"}}
                        />

                        <Input 
                            title={t("customers_comp_job")}
                            name="Phone"
                            onChange={(v) => setvalues(p => ({
                                ...p,
                                job:v,
                            }))}
                            value={values?.job}
                            style={{width:300, maxWidth:"unset"}}
                        />
                    </div>

                    <div className='sideBySideAccount' style={{display:"flex", }}>
                        
                        
                        <Select 
                            title={t("customers_emp")}
                            name="employees"
                            onChange={(v) => setvalues(p => ({
                                ...p,
                                employees:v,
                            }))}
                            values={
                                [
                                    {
                                        name:t("customers_emp_5"),
                                        val:5
                                    },
                                    {
                                        name:t("customers_emp_10"),
                                        val:10
                                    },
                                    {
                                        name:t("customers_emp_20"),
                                        val:20
                                    },
                                    {
                                        name:t("customers_emp_21"),
                                        val:"20+"
                                    }
                                
                                ]
                            }
                            value={values?.employees}
                            style={{width:300, maxWidth:"unset"}}
                        />

                        <Input 
                            title={t("customers_website")}
                            name="url"
                            placeholder={"https://"}
                            onChange={(v) => setvalues(p => ({
                                ...p,
                                url:v,
                            }))}
                            value={values?.url}
                            style={{width:300,  maxWidth:"unset"}}
                            inputStyle={{ direction:"ltr", }}
                        />

                        
                    </div>

                    <Input 
                        title={t("customers_address")}
                        type='text'
                        validate={true}
                        onChange={(v) => setvalues(p => ({
                            ...p,
                            address:v,
                        }))}
                        value={values?.address}
                        style={{width:"100%", maxWidth:"unset"}}
                    />

                 
                </div>
                
                <div className='btnBox'>

                    <button onClick={submit} className='btn'>{t("edit")}</button>
                </div>
            </div>
            
            <Footer />
		</>
	)
}
